import React, { useContext } from "react";
import whatsapp_compaign from "../../../../images/LandingPageImage/whatsapp_compaign.png";
import template from "../../../../images/LandingPageImage/template.png";
import smartflow from "../../../../images/LandingPageImage/smartflow.png";
import tracking from "../../../../images/LandingPageImage/tracking.png";
import google from "../../../../images/LandingPageImage/google.png";
import Ornament from "../../../../images/LandingPageImage/Ornament.svg";
import pattern from "../../../../images/LandingPageImage/Pattern.svg";
import { Link } from "react-router-dom";
import MyContext from "../../../../MyContext";

export default function AdvancedFeatures() {
  const { openFreeTrialModal } = useContext(MyContext);

  return (
    <section
      className="position-relative py-5 font-inter"
      style={{
        background: "linear-gradient(to top, #02151B, #088757)",
        overflow: "hidden",
      }}
    >
      <header className="text-center mb-5">
        <h2 className="display-7 fw-bold text-white font-bricolage">
          Features
        </h2>
      </header>

      <div className="container">
        <div className="row align-items-center mb-5">
          <div className="col-12 col-md-6 mb-4 mb-md-0 order-2 order-md-1">
            <div className="position-relative d-flex flex-column align-items-center justify-content-center w-100">
              <img
                src={Ornament}
                className="img-fluid w-100 h-100 object-fit-cover"
                alt="Ornament"
              />
              <img
                src={whatsapp_compaign}
                alt="whatsapp_campaign"
                className="position-absolute w-100 mt-2 object-fit-contain"
              />
            </div>
          </div>
          <div className="col-12 col-md-6 px-4 order-1 order-md-2">
            <h2
              className="h3 fw-bold font-bricolage mb-4"
              style={{ color: "yellowgreen" }}
            >
              Whatsapp Campaign
            </h2>
            <ul className="list-unstyled ps-3 mt-4 text-light">
              <li className="mb-3 d-flex align-items-start">
                <span className="me-2">•</span> Stay in touch with clients
                through real-time communication and fast response through
                WhatsApp marketing software.
              </li>
              <li className="mb-3 d-flex align-items-start">
                <span className="me-2">•</span> Send order confirmations,
                reminders, alerts, and other significant updates in real-time.
              </li>
              <li className="mb-3 d-flex align-items-start">
                <span className="me-2">•</span> Always stay in touch through
                communication where the clients spend most of their time, on
                WhatsApp.
              </li>
            </ul>
            <div className="d-flex flex-column flex-sm-row align-content-center gap-3 mt-4">
              <Link to="/login" className="text-decoration-none">
                <button
                  type="button"
                  className="btn btn-outline-google text-dark-green rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 px-2 px-sm-3 py-1 w-sm-auto"
                  style={{ minHeight: "40px" }}
                >
                  <span
                    className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                    style={{ width: "30px", height: "30px" }}
                  >
                    <img
                      src={google}
                      alt="Google"
                      className="img-fluid"
                      style={{ width: "18px", height: "18px" }}
                    />
                  </span>

                  <span className="text-nowrap">Start With Google</span>
                </button>
              </Link>

              <button
                onClick={openFreeTrialModal}
                className="btn btn-outline-demo  rounded-pill px-4 py-1 fw-semibold d-flex align-items-center justify-content-center gap-2"
              >
                Book a Demo
              </button>
            </div>
          </div>
        </div>

        <div className="row align-items-center mb-5">
          <div className="col-12 col-md-6 px-4">
            <h2
              className="h3 fw-bold font-bricolage mb-4"
              style={{ color: "yellowgreen" }}
            >
              Whatsapp Automation
            </h2>
            <ul className="list-unstyled ps-3 mt-4 text-light">
              <li className="mb-3 d-flex align-items-start">
                <span className="me-2">•</span> Automate mundane activities like
                qualifying leads, booking appointments, confirming and
                follow-ups using WhatsApp as a marketing tool.
              </li>
              <li className="mb-3 d-flex align-items-start">
                <span className="me-2">•</span> Automation can make sure that
                the clients get timely responds even when the business is not
                working.
              </li>
              <li className="mb-3 d-flex align-items-start">
                <span className="me-2">•</span> Free time on your team to give
                them time to concentrate on what is important and business
                development.
              </li>
            </ul>
            <div className="d-flex flex-column flex-sm-row align-content-center gap-3 mt-4">
              <Link to="/login" className="text-decoration-none">
                <button
                  type="button"
                  className="btn btn-outline-google text-dark-green rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 px-2 px-sm-3 py-1 w-sm-auto"
                  style={{ minHeight: "40px" }}
                >
                  <span
                    className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                    style={{ width: "30px", height: "30px" }}
                  >
                    <img
                      src={google}
                      alt="Google"
                      className="img-fluid"
                      style={{ width: "18px", height: "18px" }}
                    />
                  </span>

                  <span className="text-nowrap">Start With Google</span>
                </button>
              </Link>

              <button
                onClick={openFreeTrialModal}
                className="btn btn-outline-demo  rounded-pill px-4 py-1 fw-semibold d-flex align-items-center justify-content-center gap-2"
              >
                Book a Demo
              </button>
            </div>
          </div>
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <div className="position-relative d-flex flex-column align-items-center justify-content-center w-100">
              <img
                src={Ornament}
                className="img-fluid w-100 h-100 object-fit-cover"
                alt="Ornament"
              />
              <img
                src={template}
                alt="whatsapp_campaign"
                className="position-absolute w-100 mt-2 object-fit-contain"
              />
            </div>
          </div>
        </div>

        <div className="row align-items-center mb-5">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <div className="position-relative d-flex flex-column align-items-center justify-content-center w-100">
              <img
                src={Ornament}
                className="img-fluid w-100 h-100 object-fit-cover"
                alt="Ornament"
              />
              <img
                src={smartflow}
                alt="whatsapp_campaign"
                className="position-absolute w-100 mt-2 object-fit-contain"
              />
            </div>
          </div>
          <div className="col-12 col-md-6 px-4">
            <h2
              className="h3 fw-bold font-bricolage mb-4"
              style={{ color: "yellowgreen" }}
            >
              Whatsapp Chatbots
            </h2>
            <ul className="list-unstyled ps-3 mt-4 text-light">
              <li className="mb-3 d-flex align-items-start">
                <span className="me-2">•</span> Send messages to thousands of
                clients simultaneously using WhatsApp bulk messaging and save on
                time without impact.
              </li>
              <li className="mb-3 d-flex align-items-start">
                <span className="me-2">•</span> WhatsApp marketing software
                assists in the management of the campaign, tracking performance
                and enhancing outreach as a means of increasing results.
              </li>
              <li className="mb-3 d-flex align-items-start">
                <span className="me-2">•</span> Perfect in the case of small
                enterprises, e-commerce, service providers or start-ups that
                wish to expand effectively.
              </li>
            </ul>
            <div className="d-flex flex-column flex-sm-row align-content-center gap-3 mt-4">
              <Link to="/login" className="text-decoration-none">
                <button
                  type="button"
                  className="btn btn-outline-google text-dark-green rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 px-2 px-sm-3 py-1 w-sm-auto"
                  style={{ minHeight: "40px" }}
                >
                  <span
                    className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                    style={{ width: "30px", height: "30px" }}
                  >
                    <img
                      src={google}
                      alt="Google"
                      className="img-fluid"
                      style={{ width: "18px", height: "18px" }}
                    />
                  </span>

                  <span className="text-nowrap">Start With Google</span>
                </button>
              </Link>

              <button
                onClick={openFreeTrialModal}
                className="btn btn-outline-demo  rounded-pill px-4 py-1 fw-semibold d-flex align-items-center justify-content-center gap-2"
              >
                Book a Demo
              </button>
            </div>
          </div>
        </div>
        <div className="row align-items-center mb-5">
          <div className="col-12 col-md-6 px-4 order-2 order-md-2">
            <h2
              className="h3 fw-bold font-bricolage mb-4"
              style={{ color: "yellowgreen" }}
            >
              Analytics and Data
            </h2>
            <ul className="list-unstyled ps-3 mt-4 text-light">
              <li className="mb-3 d-flex align-items-start">
                <span className="me-2">•</span> Enhance customer satisfaction
                through quicker services and solutions of a credible WhatsApp
                marketing firm India.
              </li>
              <li className="mb-3 d-flex align-items-start">
                <span className="me-2">•</span> Efficiently control all the
                discussions and ensure high-level support and strong interaction
                with the clients.
              </li>
              <li className="mb-3 d-flex align-items-start">
                <span className="me-2">•</span> Facilitate bidirectional
                communication because clients will be able to pose questions,
                give feedback, or request services in real time.
              </li>
            </ul>
            <div className="d-flex flex-column flex-sm-row align-content-center gap-3 mt-4">
              <Link to="/login" className="text-decoration-none">
                <button
                  type="button"
                  className="btn btn-outline-google text-dark-green rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 px-2 px-sm-3 py-1 w-sm-auto"
                  style={{ minHeight: "40px" }}
                >
                  <span
                    className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                    style={{ width: "30px", height: "30px" }}
                  >
                    <img
                      src={google}
                      alt="Google"
                      className="img-fluid"
                      style={{ width: "18px", height: "18px" }}
                    />
                  </span>

                  <span className="text-nowrap">Start With Google</span>
                </button>
              </Link>

              <button
                onClick={openFreeTrialModal}
                className="btn btn-outline-demo  rounded-pill px-4 py-1 fw-semibold d-flex align-items-center justify-content-center gap-2"
              >
                Book a Demo
              </button>
            </div>
          </div>
          <div className="col-12 col-md-6 mb-4 mb-md-0 order-1 order-md-2">
            <div className="position-relative d-flex flex-column align-items-center justify-content-center w-100">
              <img
                src={Ornament}
                className="img-fluid w-100 h-100 object-fit-cover"
                alt="Ornament"
              />
              <img
                src={tracking}
                alt="whatsapp_campaign"
                className="position-absolute w-100 mt-2 object-fit-contain"
              />
            </div>
          </div>
        </div>
      </div>

      <img
        src={pattern}
        style={{
          position: "absolute",
          bottom: "0",
          left: "0",
          transform: "rotate(-90deg)",
          width: "224px",
          pointerEvents: "none",
          userSelect: "none",
        }}
        alt="decoration"
      />
    </section>
  );
}
